export const getReturnToBlogHomeLink = ({
  isNews,
  isVoices,
  isCircleOfChairs,
  isPodcast
}: {
  isNews: boolean
  isVoices: boolean
  isCircleOfChairs: boolean
  isPodcast: boolean
}): string => {
  if (isNews) {
    return 'News'
  }
  if (isVoices) {
    return 'Voices'
  }
  if (isCircleOfChairs) {
    return 'Circle of Chairs'
  }
  if (isPodcast) {
    return 'Podcasts'
  }
  return 'Learn'
}
